module.exports = __webpack_public_path__ + "img/huodong1.f3c53c09.jpg";